// /client/src/components/CreateProgram.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navigation from './Navigation';
import ProgramForm from './ProgramForm';

const CreateProgram = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        console.error('No authentication token found');
        setError('Authentication required');
        return;
      }
      
      const response = await fetch('/api/programs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        // Success - redirect to programs list with success message
        navigate('/programs', {
          state: { successMessage: 'Program created successfully!' }
        });
      } else {
        const errorData = await response.json();
        console.error('Failed to create program:', errorData);
        setError(errorData.error || 'Failed to create program');
      }
    } catch (error) {
      console.error('Error creating program:', error);
      setError('An error occurred while creating the program');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="theme-light m-0 p-0" data-theme="light">
        <div className='is-flex is-flex-direction-column is-justify-content-center'>
          
          <Navigation />
          
          <div className='mt-2 pt-6 container px-6'>
            <button 
              className="button is-small is-text mb-4"
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
            <div className='is-flex is-flex-direction-rows is-justify-content-space-between is-align-items-center'>
              <h1 className='h1 mt-2'>Create Program</h1>
            </div>
          </div>

          <div className='container px-6'>
            {error && (
              <div className="notification is-danger mb-4">
                <button 
                  className="delete" 
                  onClick={() => setError('')}
                ></button>
                {error}
              </div>
            )}
            
            <ProgramForm 
              onSubmit={handleSubmit}
              submitButtonText="Save New Program"
              isLoading={loading}
              mode="create"
            />
          </div>

        </div>
      </section>
    </>
  );
};

export default CreateProgram;